// auth.config.ts
import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'environment/environment';

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.authConfig.authority,
    showDebugInformation: true,
    redirectUri: environment.authConfig.redirectUrl,
    postLogoutRedirectUri: environment.authConfig.postLogoutRedirectUri,
    clientId: environment.authConfig.clientId,
    scope: environment.authConfig.scope,
    responseType: environment.authConfig.responseType,
    useSilentRefresh: true,
    
    // This points to a silent-refresh.html file you will create. It handles the refresh in a hidden iframe.
    silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
    // Timeout for the silent refresh process (e.g., 5 seconds).
    silentRefreshTimeout: 5000,   
};
